import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "Mitä 30 €/kk sisältää?",
    a: "Kuukausimaksu sisältää sivuston ylläpidon, palvelinkulut, tietoturvapäivitykset, varmuuskopiot ja pienet sisältöpäivitykset (esim. yhteystiedot, aukioloajat, tekstimuutokset).",
  },
  {
    q: "Kuinka nopeasti sivut valmistuvat?",
    a: "Perus-paketin sivut valmistuvat tyypillisesti 1–2 vk kartoituksen jälkeen. Näet mallisivut yrityksellesi ennen kuin maksat euroakaan.",
  },
  {
    q: "Voinko päivittää sivuja itse?",
    a: "Kyllä. Pro-paketissa saat oman hallintapaneelin, jolla voit muokata sisältöä, kuvia ja tekstejä ilman koodaustaitoja.",
  },
  {
    q: "Kuka omistaa sivuston sisällön?",
    a: "Sinä. Kaikki tekstit, kuvat, logot ja domain ovat sinun omaisuuttasi, ja domain on rekisteröity sinun nimiisi alusta alkaen. Sopimuksen päättyessä saat sisällön ja domainin mukaasi sekä staattisen kopion sivustosta. Sivuston tekninen toteutus on rakennettu MyyntiDriven käyttämällä kehitysalustalla, eikä alustaa tai sen taustajärjestelmää luovuteta. Jatkat siis omalla sisällölläsi ja domainilla, uudella toteutuksella.",
  },
  {
    q: "Onko sitoutumisaikaa?",
    a: "12 kk sitoutuminen, jonka jälkeen irtisanominen kuukauden irtisanomisajalla.",
  },
  {
    q: "Mitä tarvitsen aloittaakseni?",
    a: "Vain 15 minuuttia aikaa maksuttomaan kartoituspuheluun. Käymme läpi tavoitteesi ja saat konkreettisen ehdotuksen 24 tunnin sisällä.",
  },
];

export default function FAQ() {
  return (
    <section className="md-section" id="ukk" data-testid="faq-section">
      <div className="md-container max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14"
        >
          <span className="md-eyebrow">UKK</span>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Usein kysytyt <span className="text-[#00E5FF]">kysymykset.</span>
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="md-card px-6 border data-[state=open]:border-[#0066FF]/40"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger className="text-left text-white hover:no-underline font-display text-lg py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
